import { render, staticRenderFns } from "./skeletonIndex.vue?vue&type=template&id=a6ee1af2&scoped=true"
import script from "./skeletonIndex.vue?vue&type=script&lang=js"
export * from "./skeletonIndex.vue?vue&type=script&lang=js"
import style0 from "./skeletonIndex.vue?vue&type=style&index=0&id=a6ee1af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ee1af2",
  null
  
)

export default component.exports